import React from "react";
import LogOutButton from "../LogOutButton/LogOutButton";
import CopyToken from "../CopyToken/CopyToken";
import LauncherButton from "../LauncherButton/LauncherButton";
import { isProEnvironment } from "../../utils";
import { useConfigProvider } from "../../contexts/ConfigProvider";

type Props = {
  token: string;
};

const FloatingButtons: React.FC<Props> = ({ token }): JSX.Element => {
  const { features } = useConfigProvider();
  return (
    <>
      {features.withLogin && <LogOutButton />}
      {!isProEnvironment() && features.withLogin && token !== "withguest" && <CopyToken token={token} />}
      {!isProEnvironment() && features.withLauncher && <LauncherButton />}
    </>
  );
};

export default FloatingButtons;
